export default __webpack_public_path__ + "static/rimes-7513bf7cbe7ad6cda58b7a0dcb645072.jpg";